import { InsertLinksStatus } from '../types/InsertLinksStatus';
import { getFailedInsertLinkIds } from '../utils/getFailedInsertLinkIds';
import { getPendingInsertLinkIds } from '../utils/getPendingInsertLinkIds';
import { getFileNamesString } from '../selectors/getFileNamesString';

export function getInsertLinksStatusData(
    insertLinksIds: string[]
): { status: InsertLinksStatus; fileNames: string } {
    const pendingIds: string[] = getPendingInsertLinkIds(insertLinksIds);

    if (pendingIds.length > 1) {
        return { status: InsertLinksStatus.loadingMultipleLinks, fileNames: null };
    } else if (pendingIds.length === 1) {
        return { status: InsertLinksStatus.loadingOneLink, fileNames: null };
    }

    const failedIds: string[] = getFailedInsertLinkIds(insertLinksIds);
    const fileNamesString: string = getFileNamesString(failedIds);
    if (failedIds.length > 1) {
        return {
            status: InsertLinksStatus.failedToInsertMultipleLinks,
            fileNames: fileNamesString,
        };
    } else if (failedIds.length === 1) {
        return { status: InsertLinksStatus.failedToInsertOneLink, fileNames: fileNamesString };
    }

    if (insertLinksIds.length > 1) {
        return { status: InsertLinksStatus.succeededToAddMultipleLinks, fileNames: null };
    }

    return { status: InsertLinksStatus.succeededToAddOneLink, fileNames: null };
}
